module.exports = __webpack_public_path__ + "public/img/qrcode-qq.fbe11714.png";